

/**
 * 枚举
 */
const enums = {
  userType: {
    0: '普通',
    1: '企业',
    2: '普通',
    14: '专家',
    22: '行家'
  },
  noticeType: {
    '1': '粉丝',
    '2': '交换名片',
    '3': '新评论',
    '4': '下线',
    '5': '付费',
    '6': '打赏',
    '7': '服务开通',
    '8': '服务开通',
    '9': '服务关闭',
    '10': '被订阅',
    '11': '被打赏',
    '12': '待审核',
    '13': '审核通过',
    '14': '审核不通过',
    '15': '系统',
    '16': '上线'
  }

}
export default enums